// This component is created for KLM-8944

import React from 'react'
import { Grid } from 'semantic-ui-react';
import { dispatch } from '@rematch/core';
import { withRouter } from 'react-router-dom';
import CountUp from 'react-countup';
class PbBlock extends React.Component {

    goToPage(e, pageType, pageName) {
        dispatch.home.redirectFromEventStream(true)
        const history = this.props.history;
        let urlPath = ""
        if (pageType === 'playbook') {
            if (pageName === 'In Design') {
                // urlPath = '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.selectedOrganisation.id + '/_pb/status/In Design'
                history.push({pathname: `/app/${this.props.match.params.accountId}/_ws/${this.props.selectedOrganisation.id}/_pb/status/In Design`})
                dispatch.lifeCycle.setTreeCurrentPath("0/0")
            } if (pageName === 'Approved') {
                // urlPath = '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.selectedOrganisation.id + '/_pb/status/Approved'
                history.push({pathname: `/app/${this.props.match.params.accountId}/_ws/${this.props.selectedOrganisation.id}/_pb/status/Approved`})
                dispatch.lifeCycle.setTreeCurrentPath("0/2")
            } if (pageName === 'Published') {
                // urlPath = '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.selectedOrganisation.id + '/_pb/status/Published'
                history.push({pathname: `/app/${this.props.match.params.accountId}/_ws/${this.props.selectedOrganisation.id}/_pb/status/Published`})
                dispatch.lifeCycle.setTreeCurrentPath("0/3")
            } if (pageName === 'Inactive') {
                // urlPath = '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.selectedOrganisation.id + '/_pb/status/Inactive'
                history.push({pathname: `/app/${this.props.match.params.accountId}/_ws/${this.props.selectedOrganisation.id}/_pb/status/Inactive`})
                dispatch.lifeCycle.setTreeCurrentPath("0/4")
            } if (pageName === 'Generating') {
                // urlPath = '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.selectedOrganisation.id + '/_pb/status/Inactive'
                history.push({pathname: `/app/${this.props.match.params.accountId}/_ws/${this.props.selectedOrganisation.id}/_pb/status/Generating`})
                dispatch.lifeCycle.setTreeCurrentPath("0/5")
            }

            // history.push({
            //     pathname: urlPath
            // });
        }

        else if (pageType === 'community') {
            dispatch.home.redirectFromEventStream(true)
            dispatch.app.showToolbar(true)
            if (pageName === "Teams") {
                dispatch.community.addMainAreaContext('ORGANIZATION');
                dispatch.community.setAddUserContextData('Teams');
                urlPath = '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.selectedOrganisation.id + '/_cm/team/' + this.props.selectedOrganisation.id
            } else if (pageName === "Users") {
                dispatch.invite.storeUserRole("users");
                dispatch.community.setAddUserContextData('Users');
                dispatch.community.addMainAreaContext('USERS');
                dispatch.users.userTreeSelectedPath("0")
                urlPath = urlPath = '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.selectedOrganisation.id + '/_cm/userList/' + this.props.selectedOrganisation.id + '/users'
            } else if (pageName === 'Invitations') {
                dispatch.invite.storeUserRole("Invitations");
                dispatch.community.addMainAreaContext('USERS');
                dispatch.community.setAddUserContextData('Users');
                dispatch.users.userTreeSelectedPath("1")
                urlPath = '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.selectedOrganisation.id + '/_cm/userList/' + this.props.selectedOrganisation.id + '/Invitations'
            }

            history.push({
                pathname: urlPath
            });
        }
    }


    render() {
        const integrate = this.props.selectedAccount.integrations && this.props.selectedAccount.integrations.some(int => int.isActive && int.id.id === "openai")
        return (
            <Grid columns="equal" celled='internally' className="count-block-item setHoverEffect" >
                <Grid.Row>
                    <Grid.Column onClick={(e) => this.goToPage(e, this.props.type, this.props.label1Name)}>
                        {this.props.isLoadingData ?
                            <CountUp end={this.props.label1Count} duration={5} /> :
                            <span>{this.props.label1Count}</span>
                        }
                        <label>{this.props.label1Name}</label>
                    </Grid.Column>
                    <Grid.Column className={`${this.props.label2Name === 'Active' ? "bdr_btm_none" : ''}`} onClick={(e) => this.goToPage(e, this.props.type, this.props.label2Name)}>
                        {this.props.isLoadingData ?
                            <CountUp end={this.props.label2Count} duration={5} /> :
                            <span>{this.props.label2Count}</span>
                        }
                        <label>{this.props.label2Name}</label>
                    </Grid.Column>
                    <Grid.Column onClick={(e) => this.goToPage(e, this.props.type, this.props.label3Name)}>
                        {this.props.isLoadingData ?
                            <CountUp end={this.props.label3Count} duration={5} /> :
                            <span>{this.props.label3Count}</span>
                        }
                        <label>{this.props.label3Name}</label>
                    </Grid.Column>
                    <Grid.Column onClick={(e) => this.goToPage(e, this.props.type, this.props.label4Name)}>
                        {this.props.isLoadingData ?
                            <CountUp end={this.props.label4Count} duration={5} /> :
                            <span>{this.props.label4Count}</span>
                        }
                        <label>{this.props.label4Name}</label>
                    </Grid.Column>
                    {integrate && <Grid.Column onClick={(e) => this.goToPage(e, this.props.type, this.props.label5Name)}>
                        {this.props.isLoadingData ?
                            <CountUp end={this.props.label5Count} duration={5} /> :
                            <span>{this.props.label5Count}</span>
                        }
                        <label>{this.props.label5Name}</label>
                    </Grid.Column>}
                </Grid.Row>

            </Grid >
        )
    }
}


export default withRouter(PbBlock);